export const CLASSY_ATTR = 'classy'
export const CLASSY_HREF = 'campaign'
